import { graphql } from 'gql';

export const gqlWorkOrderVersionPriceList = graphql(`
    query uerWorkOrderVersionPriceList(
        $workOrderId: Long!
        $workOrderObjectId: Long!
        $chapter: ChapterEnum!
        $where: WorkOrderVersionPriceDataFilterInput
    ) {
        uerWorkOrderVersionPriceList(
            workOrderVersionId: $workOrderId
            chapter: $chapter
            workOrderVersionObjectId: $workOrderObjectId
            where: $where
        ) {
            items {
                id
                parentId
                type
                status
                uerCodeId
                uerId
                uerCode
                priceListId
                code
                name
                unit
                unitCost
                totalPlanVolume
                totalPlanCost
                totalCompletedVolume
                totalCompletedCost
                totalRemainderVolume
                totalRemainderCost
                seasonPrices {
                    id
                    completedCost
                    completedVolume
                    planCost
                    planVolume
                    remainderCost
                    remainderVolume
                    planVolumeTerms
                    seasonId
                }
                actKC2VersionPrices {
                    id
                    planVolume
                    planCost
                    acceptedCost
                    acceptedVolume
                    acceptedVolumeDeviation
                    actKC2VersionId
                    actKC2VersionSeasonId
                    actKC2VersionStatus
                    planVolumeDeviation
                }
                isActKC2VersionPrice
                hasEmptySeasonVolume
                hasEmptyActVersionPlanVolume
                hasEmptyActVersionAcceptedVolume
                workCode
                workCompleted
                workInSum
                workName
                workPlan
                workRatio
                workReminder
                workUnit
            }
        }
    }
`);

export const gqlWorkOrderVersionActsKC2Version = graphql(`
    query uerWorkOrderVersionActsKC2Version(
        $workOrderVersionId: Long!
        $workOrderVersionObjectId: Long
        $order: [WorkOrderVersionActKC2VersionDataSortInput!]
        $where: WorkOrderVersionActKC2VersionDataFilterInput
    ) {
        uerWorkOrderVersionActsKC2Version(
            workOrderVersionId: $workOrderVersionId
            workOrderVersionObjectId: $workOrderVersionObjectId
            order: $order
            where: $where
        ) {
            date
            id
            number
            fullNumber
            isInactive
            isCorrection
            correctionDate
            correctionNumber
            seasonId
            status
        }
    }
`);

export const gqlWorkOrderVersion = graphql(`
    query uerWorkOrderVersion($workOrderId: Long!) {
        uerWorkOrderVersion(workOrderVersionId: $workOrderId) {
            data {
                id
                name
                internalNumber
                subject
                status
                contractor
                contractorAddress
                signingDate
                amountWithTax
                amountWithoutTax
                remainder
                tax
                startDate
                finishDate
                inflationData {
                    id
                    year
                    inflationRate
                }
                vorType
                workOrderChange {
                    id
                    internalNumber
                    signingDate
                }
            }
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const gqlWorkOrderVersionObjects = graphql(`
    query uerWorkOrderVersionObjects($workOrderVersionId: Long!, $where: WorkOrderVersionObjectDataFilterInput) {
        uerWorkOrderVersionObjects(workOrderVersionId: $workOrderVersionId, where: $where) {
            items {
                codeWBS
                code
                constructionType {
                    code
                    id
                    name
                    shortName
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                hasPrices
                hasPricesOther
                id
                name
                parentId
                rootObjectId
                status
                workOrderVersionId
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const gqlWorkOrderVersionSeasons = graphql(`
    query uerWorkOrderVersionSeasons($workOrderVersionId: Long!) {
        uerWorkOrderVersionSeasons(workOrderVersionId: $workOrderVersionId) {
            id
            year
        }
    }
`);

export const gqlWorkOrderVersionObjectResults = graphql(`
    query uerWorkOrderVersionObjectResults(
        $chapter: ChapterEnum
        $section: SectionEnum
        $workOrderVersionId: Long!
        $workOrderVersionObjectId: Long!
        $order: [WorkOrderVersionObjectResultDataSortInput!]
        $where: WorkOrderVersionObjectResultDataFilterInput
    ) {
        uerWorkOrderVersionObjectResults(
            chapter: $chapter
            section: $section
            workOrderVersionId: $workOrderVersionId
            workOrderVersionObjectId: $workOrderVersionObjectId
            order: $order
            where: $where
        ) {
            actKC2VersionId
            chapter
            constructionTypeId
            costResults {
                name
                value
                year
            }
            objectId
            section
            sortOrder
            title
        }
    }
`);

export const gqlWorkOrderVersionResults = graphql(`
    query uerWorkOrderVersionResults(
        $workOrderVersionId: Long!
        $order: [WorkOrderVersionResultDataSortInput!]
        $where: WorkOrderVersionResultDataFilterInput
    ) {
        uerWorkOrderVersionResults(workOrderVersionId: $workOrderVersionId, order: $order, where: $where) {
            actKC2VersionResults {
                actKC2VersionId
                value
            }
            chapter
            resultSectionId
            seasonResults {
                seasonId
                value
            }
            section
            sortOrder
            title
            totalCompletedCost
            totalPlanCost
            totalRemainderCost
        }
    }
`);

export const uerWorkOrderVersionPriceItems = graphql(`
    query uerWorkOrderVersionPriceItems(
        $skip: Int
        $take: Int
        $workOrderVersionId: Long!
        $constructionTypeId: Int!
        $where: WorkOrderVersionPriceItemFilterInput
    ) {
        uerWorkOrderVersionPriceItems(
            skip: $skip
            take: $take
            workOrderVersionId: $workOrderVersionId
            constructionTypeId: $constructionTypeId
            where: $where
        ) {
            totalCount
            items {
                calculatingType
                calculatingTypeValue
                chapter
                clientId
                code
                constructionTypeId
                entityTypeId
                entityTypeName
                entityTypeUniqueId
                entryId
                hasDuplicates
                hasEmptySeasonVolume
                hasLimitSpan
                isActKC2Price
                isCreatedFromSKzS
                isExcludedPrice
                isOtherGroup
                isOtherItem
                isRootObject
                isSMRItem
                itemId
                name
                objectId
                objectName
                rationale
                rootObjectId
                rootObjectName
                seasonValues {
                    actValues {
                        actCostAccepted
                        actCostAcceptedDeviation
                        actCostGroup
                        actCostPlan
                        actCostPlanDeviation
                        actHasEditableCost
                        actId
                        actInflationSeasonId
                        actStatus
                        actStatusSKzS
                        actVolumeAccepted
                        actVolumeAcceptedDeviation
                        actVolumeIsReadOnly
                        actVolumePlan
                        actVolumePlanDeviation
                        actVolumePlanSKzS
                        comment
                        isActKC2DistributionOfMtrInflation
                        isCorrection
                        isInactive
                        isSKzS
                    }
                    completedCost
                    completedVolume
                    errors
                    hasErrors
                    itemTip
                    planCost
                    planTerms
                    planVolume
                    priceId
                    remainderCost
                    remainderVolume
                    seasonId
                    seasonYear
                }
                sortOtherPart
                sortPart
                sortSMRPart
                status
                statusTip
                totalCompletedCost
                totalCompletedVolume
                totalPlanCost
                totalPlanVolume
                totalRemainderCost
                totalRemainderVolume
                type
                uerCode
                uerCodeId
                uerId
                unit
                unitCost
                workCode
                workCompleted
                workInSum
                workKindWorkRatio
                workName
                workPlan
                workRatio
                workReminder
                workUnit
            }
        }
    }
`);

export const uerWorkOrderVersionTotals = graphql(`
    query uerWorkOrderVersionTotals($workOrderVersionId: Long!) {
        uerWorkOrderVersionTotals(workOrderVersionId: $workOrderVersionId) {
            actionRequired
            buttonText
            code
            data {
                isHeadLine
                name
                seasonTotals {
                    completedCost
                    planCost
                    seasonId
                }
                totalCompletedCost
                totalPlanCost
                totalRemainderCost
            }
            hasValidation
            hideValidation
            message
            result
        }
    }
`);

export const uerWorkOrderVersionObjectTotals = graphql(`
    query uerWorkOrderVersionObjectTotals($workOrderVersionId: Long!, $workOrderVersionObjectId: Long!) {
        uerWorkOrderVersionObjectTotals(
            workOrderVersionId: $workOrderVersionId
            workOrderVersionObjectId: $workOrderVersionObjectId
        ) {
            actionRequired
            buttonText
            code
            data {
                isHeadLine
                name
                seasonTotals {
                    completedCost
                    planCost
                    seasonId
                }
                totalCompletedCost
                totalPlanCost
                totalRemainderCost
            }
            hasValidation
            hideValidation
            message
            result
        }
    }
`);

export const uerWorkOrderVersionPriceItemChapterFilter = graphql(`
    query uerWorkOrderVersionPriceItemChapterFilter(
        $skip: Int
        $take: Int
        $workOrderVersionId: Long!
        $constructionTypeId: Int!
        $rootObjectId: Long
        $objectId: Long
        $where: FilterValueOfNullableOfChapterEnumFilterInput
    ) {
        uerWorkOrderVersionPriceItemChapterFilter(
            skip: $skip
            take: $take
            workOrderVersionId: $workOrderVersionId
            constructionTypeId: $constructionTypeId
            rootObjectId: $rootObjectId
            objectId: $objectId
            where: $where
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerWorkOrderVersionPriceItemStatusFilter = graphql(`
    query uerWorkOrderVersionPriceItemStatusFilter(
        $skip: Int
        $take: Int
        $workOrderVersionId: Long!
        $constructionTypeId: Int!
        $rootObjectId: Long
        $objectId: Long
        $where: FilterValueOfNullableOfWorkOrderPriceStatusEnumFilterInput
    ) {
        uerWorkOrderVersionPriceItemStatusFilter(
            skip: $skip
            take: $take
            workOrderVersionId: $workOrderVersionId
            constructionTypeId: $constructionTypeId
            rootObjectId: $rootObjectId
            objectId: $objectId
            where: $where
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerWorkOrderVersionPriceItemCodeFilter = graphql(`
    query uerWorkOrderVersionPriceItemCodeFilter(
        $skip: Int
        $take: Int
        $workOrderVersionId: Long!
        $constructionTypeId: Int!
        $rootObjectId: Long
        $objectId: Long
        $where: FilterValueOfWorkOrderPriceItemCodeFilterDataFilterInput
    ) {
        uerWorkOrderVersionPriceItemCodeFilter(
            skip: $skip
            take: $take
            workOrderVersionId: $workOrderVersionId
            constructionTypeId: $constructionTypeId
            rootObjectId: $rootObjectId
            objectId: $objectId
            where: $where
        ) {
            items {
                value {
                    code
                    isMtr
                    isRatio
                    isUer
                    sortSMRPart
                    uerCode
                    uerCodeId
                }
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerWorkOrderVersionPriceItemNameFilter = graphql(`
    query uerWorkOrderVersionPriceItemNameFilter(
        $skip: Int
        $take: Int
        $workOrderVersionId: Long!
        $constructionTypeId: Int!
        $rootObjectId: Long
        $objectId: Long
        $where: FilterValueOfStringFilterInput
    ) {
        uerWorkOrderVersionPriceItemNameFilter(
            skip: $skip
            take: $take
            workOrderVersionId: $workOrderVersionId
            constructionTypeId: $constructionTypeId
            rootObjectId: $rootObjectId
            objectId: $objectId
            where: $where
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerWorkOrderVersionPriceItemUnitFilter = graphql(`
    query uerWorkOrderVersionPriceItemUnitFilter(
        $skip: Int
        $take: Int
        $workOrderVersionId: Long!
        $constructionTypeId: Int!
        $rootObjectId: Long
        $objectId: Long
        $where: FilterValueOfStringFilterInput
    ) {
        uerWorkOrderVersionPriceItemUnitFilter(
            skip: $skip
            take: $take
            workOrderVersionId: $workOrderVersionId
            constructionTypeId: $constructionTypeId
            rootObjectId: $rootObjectId
            objectId: $objectId
            where: $where
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerWorkOrderVersionPriceItemWorkNameFilter = graphql(`
    query uerWorkOrderVersionPriceItemWorkNameFilter(
        $skip: Int
        $take: Int
        $workOrderVersionId: Long!
        $constructionTypeId: Int!
        $rootObjectId: Long
        $objectId: Long
        $where: FilterValueOfStringFilterInput
    ) {
        uerWorkOrderVersionPriceItemWorkNameFilter(
            skip: $skip
            take: $take
            workOrderVersionId: $workOrderVersionId
            constructionTypeId: $constructionTypeId
            rootObjectId: $rootObjectId
            objectId: $objectId
            where: $where
        ) {
            items {
                value
            }
            totalCount
        }
    }
`);

export const uerWorkOrderVersionPriceItemWorkInSumFilter = graphql(`
    query uerWorkOrderVersionPriceItemWorkInSumFilter(
        $skip: Int
        $take: Int
        $workOrderVersionId: Long!
        $constructionTypeId: Int!
        $rootObjectId: Long
        $objectId: Long
        $where: FilterValueOfNullableOfWorkInSumEnumFilterInput
    ) {
        uerWorkOrderVersionPriceItemWorkInSumFilter(
            skip: $skip
            take: $take
            workOrderVersionId: $workOrderVersionId
            constructionTypeId: $constructionTypeId
            rootObjectId: $rootObjectId
            objectId: $objectId
            where: $where
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);
